let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5CiUy")).then(() => parcelRequire('jBnrF'));